import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {AddButton} from "../AddButton/AddButton";
import React from "react";
import {DeleteButton} from "../DeleteButton/DeleteButton";

export const FillerSection = ({children, title, onAddButtonClick, onDeleteButtonClick, disabledAddButton, disabledDeleteButton}) => {
    return <Grid item container direction={'column'} spacing={1}>
        <Grid item container alignItems={"center"}>
            <Grid item>
                <Typography variant={'subtitle2'}>{title}</Typography>
            </Grid>
            {
                onAddButtonClick ?
                    <Grid item>
                        <AddButton onClick={onAddButtonClick} disabled={disabledAddButton}/>
                    </Grid> : null
            }
            {
                onDeleteButtonClick ?
                    <Grid item container xs justifyContent={'flex-end'}>
                        <Grid item>
                            <DeleteButton onClick={onDeleteButtonClick} disabled={disabledDeleteButton}/>
                        </Grid>
                    </Grid>: null
            }
        </Grid>
        <Grid item container>
            {children}
        </Grid>
    </Grid>
}